import { render } from "./vagentappointdvc.vue?vue&type=template&id=bbd7f71c&scoped=true"
import script from "./vagentappointdvc.vue?vue&type=script&lang=js"
export * from "./vagentappointdvc.vue?vue&type=script&lang=js"

import "./vagentappointdvc.vue?vue&type=style&index=0&id=bbd7f71c&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbd7f71c"]])

export default __exports__